<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <base-material-card
          color="primary"
          icon="mdi-bank"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Sites Management
            </div>
          </template>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-col>
          <v-row>
            <v-col
              sm="12"
            >
              <v-card
                class="pa-2"
                outlined
                tile
              >
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-dialog
                    v-if="postalgroup"
                    v-model="dialogusps"
                    max-width="700px"
                  >
                    <v-card>
                      <v-toolbar>
                        <v-toolbar-title>Address Validation</v-toolbar-title>

                        <v-progress-linear
                          :active="loading"
                          :indeterminate="loading"
                          absolute
                          bottom
                          color="deep-purple accent-4"
                        />

                        <v-spacer />
                        <v-btn
                          color="deep-purple accent-4"
                          @click="validateAddress(editedItem)"
                        >
                          Check Address
                        </v-btn>
                      </v-toolbar>
                      <v-row>
                        <v-col
                          cols="12"
                        >
                          <v-img
                            height="150"
                            contain
                            src="/img/uspslogo.png"
                          />
                        </v-col>
                        <v-col
                          cols="6"
                        >
                          <v-list>
                            <v-list-item>
                              <v-list-item-icon>
                                <v-icon large>
                                  mdi-store-marker
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Site Name: {{ editedItem.idnum }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-icon>
                                <v-icon large>
                                  mdi-text-box-multiple
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Address: {{ editedItem.address }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-icon>
                                <v-icon large>
                                  mdi-city
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>City: {{ editedItem.city }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-icon>
                                <v-icon large>
                                  mdi-map-legend
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>State: {{ editedItem.state }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                        <v-col
                          cols="6"
                        >
                          <v-list>
                            <v-list-item v-if="postalMessage">
                              <v-list-item-icon>
                                <v-icon large>
                                  mdi-account-voice
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                {{ postalMessage }}
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                      <v-row class="ma-2">
                        <v-col />
                      </v-row>
                      <v-card-actions>
                        <v-btn
                          color="blue darken-1"
                          outlined
                          @click="closeusps"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="dialog"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="success"
                        dark
                        class="mb-2"
                        v-on="on"
                      >
                        Add Postal Site
                      </v-btn>
                    </template>
                    <v-form ref="form">
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-text-field
                                  v-model="editedItem.idnum"
                                  :rules="rules"
                                  label="Site Name"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-text-field
                                  v-model="editedItem.address"
                                  label="Address"
                                  :rules="reqRule"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-text-field
                                  v-model="editedItem.city"
                                  label="City"
                                  :rules="reqRule"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-select
                                  v-model="editedItem.state"
                                  :items="getstates"
                                  label="State"
                                  :rules="reqRule"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-text-field
                                  v-model="editedItem.zipcode"
                                  label="Zipcode"
                                  :rules="zipRules"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                              >
                                <v-text-field
                                  v-model="editedItem.sitecontactnumber"
                                  label="Contact Number"
                                  :rules="phoneRules"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.sitecontactname"
                                  label="Contact Name"
                                  :rules="reqRule"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.group"
                                  disabled
                                  label="Group"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                              >
                                <v-autocomplete
                                  v-model="editedItem.allowedusers"
                                  :items="userlist(editedItem.group)"
                                  attach
                                  chips
                                  label="User Access"
                                  multiple
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="12"
                              >
                                <v-text-field
                                  v-model="editedItem.supportemail"
                                  label="Support Email"
                                  :rules="emailRules"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                              >
                                <v-text-field
                                  v-model="editedItem.supportnumber"
                                  label="Support Number"
                                  :rules="phoneRules"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                              >
                                <v-select
                                  v-model="editedItem.timezone"
                                  :items="supportedTimezones"
                                  label="Time Zone"
                                  :rules="reqRule"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="blue darken-1"
                            @click="close"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            :disabled="!formIsValid"
                            @click="save"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-form>
                  </v-dialog>
                  <v-spacer />
                  <v-btn
                    color="warning"
                    dark
                    class="mb-2"
                    to="/EstateManagement"
                  >
                    Return
                  </v-btn>
                </v-toolbar>

                <v-data-table
                  :headers="headers"
                  :search="search"
                  :items="currentmachines"
                  item-key="idnum"
                  class="elevation-1"
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                >
                  <template v-slot:items="props">
                    <td class="text-left">
                      {{ props.item.idnum }}
                    </td>
                    <td class="text-left">
                      {{ props.item.group }}
                    </td>
                    <td class="text-left">
                      {{ props.item.address }}, {{ props.item.city }} {{ props.item.zipcode }}
                    </td>
                    <td class="text-left">
                      {{ props.item.sitecontactnumber }}
                    </td>
                    <td class="text-left">
                      {{ props.item.sitecontactname }}
                    </td>
                    <td class="text-left">
                      {{ props.item.wifipw }}
                    </td>
                    <td class="text-left">
                      {{ props.item.wifiaccess }}
                    </td>
                    <td class="text-left">
                      {{ props.item.timezone }}
                    </td>
                    <td class="text-left">
                      {{ props.item.time_open }} Hrs
                    </td>
                    <td class="text-left">
                      {{ props.item.time_close }} Hrs
                    </td>
                    <td class="text-left">
                      {{ props.item.time_eod }} Hrs
                    </td>
                  </template>
                  <template
                    v-if="userallowed"
                    v-slot:[`item.verify`]="{ item }"
                  >
                    <v-icon

                      color="purple lighten-1"
                      size="20"
                      @click="verifyItem(item)"
                    >
                      mdi-email-search
                    </v-icon>
                  </template>
                  <template
                    v-if="userallowed"
                    v-slot:[`item.action`]="{ item }"
                  >
                    <v-icon

                      color="primary"
                      size="20"
                      @click="editItem(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon

                      color="black"
                      size="20"
                      class="ma-4"
                      @click="deleteItem(item)"
                    >
                      mdi-delete-forever
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary">
                      Reset
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </base-material-card>

        <v-spacer />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Components
  import { nanoid } from 'nanoid'

  export default {
    data: () => ({
      search: '',
      dialog: false,
      dialogusps: false,
      dialogpostalwizard: false,
      time: null,
      newgroup: '',
      snackbar: false,
      syncChange: false,
      changeProvider: ['Safe and Sound'],
      singleExpand: true,
      expanded: [],
      timeout: 5000,
      virtualSafeId: '',
      alertmessage: '',
      currentgroups: '',
      showchange: false,
      singleSelect: false,
      headers_change: [
        { text: 'Label', align: 'left', value: 'label', sortable: false },
        { text: 'Group', align: 'left', value: 'group', sortable: false },
      ],
      sitetype: ['physical', 'virtual', 'postal'],
      scheduletype: ['daily', 'weekly', 'biweekly', 'monthly'], // we calc iso week as some months shorter, some longer
      supportedTimezones: ['EST', 'CST', 'MST', 'PST', 'GMT'],
      locationTags: ['Restaurants', 'Retail', 'Parking', 'Car Wash', 'Other'],
      safeType: ['Single Note', 'Tray Fed', 'High Speed'],
      noteCapacity: ['600', '1000', '2000', '3000', '4000', '10000', '20000'],
      provCredit: false,
      creditprovider: ['DTSConnex', 'CashConnect', 'Signature', 'Dimebank', 'Paythings', 'Other'],
      creditproviderId: '',
      externalsafe: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      modal2: false,
      headers: [
        { text: 'Site Name', value: 'idnum', align: 'left', width: 200 },
        { text: 'Group', value: 'group', align: 'left' },
        { text: 'Address', value: 'address', align: 'left', width: 200 },
        { text: 'Time Zone', value: 'timezone', align: 'center' },
        { text: 'Open', value: 'time_open', align: 'center' },
        { text: 'Close', value: 'time_close', align: 'center' },
        { text: 'Contact number', value: 'sitecontactnumber', align: 'center' },
        { text: 'USPS Verify', value: 'verify', align: 'center', sortable: false },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      sites: [],
      zipRules: [
        v => !!v || 'Zipcode is required',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v).length === 5 || 'Numbers must be 5 digits, US Zipcode only',
      ],
      reqRule: [
        v => !!v || 'field is required',
      ],
      phoneRules: [
        v => !!v || 'Phone number is required',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v).length === 11 || 'Numbers must be 10 digits, US Number with (area code) (phone number)',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      group: '',
      allowSpaces: true,
      unique: true,
      filterchars: true,
      onlyspace: false,
      max: 50,
      editedIndex: -1,
      editedItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        nightlyrestart: '',
        sitekey: '',
        sitetype: '',
        schedule: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        group: '',
        shipmentspermonth: '',
        changeSystemID: '',
        changeProvider: '',
        allowedusers: null,
        changeorderprofiles: [],
        locationTags: null,
        safeType: 'none',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        creditproviderapikey: '',
        wifipw: '',
        externalsafe: false,
        wifiaccess: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '08:00',
        time_close: '23:00',
        time_eod: '01:00',
        time_deposit_summary: ''
      },
      defaultItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        nightlyrestart: '',
        address: '',
        sitekey: '',
        sitetype: '',
        shipmentspermonth: '',
        schedule: '',
        city: '',
        state: '',
        zipcode: '',
        externalsafe: false,
        wifipw: '',
        wifiaccess: '',
        group: '',
        changeSystemID: '',
        changeProvider: '',
        allowedusers: [],
        changeorderprofiles: [],
        locationTags: [],
        safeType: '',
        noteCapacity: '',
        provCredit: false,
        creditprovider: '',
        creditproviderId: '',
        creditproviderLocationID: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '08:00',
        time_close: '23:00',
        time_eod: '01:00',
        time_deposit_summary: ''
      }
    }),

    computed: {
      postalMessage () {
        let message = ''
        message = this.$store.getters.getPostalMessage
        return message
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      rules () {
        const rules = []

        if (this.unique) {
          // if current site name is not the value
          console.log('adding unique rule')
          const rule =
            v => (!this.sites.map(entry => entry.idnum).includes(v)) ||
              'Values must be unique and not be an existing site name'

          rules.push(rule)
        }
        if (!this.onlyspace) {
          const rule =
            v => v.trim().length || 'Name can not be only whitespace characters'

          rules.push(rule)
        }
        if (this.max) {
          const rule =
            v => (v || '').length <= this.max ||
              `A maximum of ${this.max} characters is allowed in a site name`

          rules.push(rule)
        }

        if (!this.allowSpaces) {
          const rule =
            v => (v || '').indexOf(' ') < 0 ||
              'No spaces are allowed'

          rules.push(rule)
        }
        if (this.filterchars) {
          const rule =
            v => !v.match(/\\t|[#\$\[\]\.]/gi) || ' $ # [ ] tabs are not allowed in a site name'
          rules.push(rule)
        }
        return rules
      },
      postalgroup () {
        return true
      },
      formIsValid () {
        console.log('is it valid? ', this.editedItem)
        return this.editedItem.idnum !== '' &&
          this.editedItem.address !== '' &&
          this.editedItem.city !== '' &&
          this.editedItem.state !== '' &&
          this.editedItem.zipcode !== '' &&
          this.editedItem.group !== '' &&
          this.editedItem.timezone !== '' &&
          this.editedItem.time_open !== '' &&
          this.editedItem.time_close !== '' &&
          this.editedItem.time_eod !== '' &&
          !this.sites.map(entry => entry.idnum).includes(this.editedItem.idnum)
      },
      getcurrentgroups () {
        this.$log.debug('groups', this.$store.getters.usergroups)
        this.currentgroups = this.$store.getters.usergroups
        return this.currentgroups
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      changeorderprofilelist () {
        return this.$store.getters.getLoadedChangeProfiles
      },
      getstates () {
        let state_hash = [
          'AL',
          'AK',
          'AS',
          'AZ',
          'AR',
          'CA',
          'CO',
          'CT',
          'DE',
          'DC',
          'FM',
          'FL',
          'GA',
          'GU',
          'HI',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'ME',
          'MH',
          'MD',
          'MA',
          'MI',
          'MN',
          'MS',
          'MO',
          'MT',
          'NE',
          'NV',
          'NH',
          'NJ',
          'NM',
          'NY',
          'NC',
          'ND',
          'MN',
          'MP',
          'OH',
          'OK',
          'OR',
          'PW',
          'PA',
          'PR',
          'RI',
          'SC',
          'SD',
          'TN',
          'TX',
          'UT',
          'VT',
          'VI',
          'VA',
          'WA',
          'WV',
          'WI',
          'WY'
        ]
        return state_hash
      },
      userallowed () {
        if (parseInt(this.$store.getters.user.level) >= 500 || this.$store.getters.user.status === 'corporate') {
          console.log('user allowed', this.$store.getters.user.level)

          return true
        }
        this.$log.debug('user NOT allowed', this.$store.getters.user.level)

        return false
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Site' : 'Edit Site'
      },
      currentmachines () {
        this.sites = this.$store.getters.loadedSites
        return this.sites.filter(entry => entry.group === this.group)
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogusps (val) {
        val || this.closeusps()
      },
    },
    created () {
      this.group = this.$route.params.id
      this.editedItem.group = this.group
      this.virtualSafeId = 'PostalSafe-' + nanoid()

      this.$store.dispatch('loadgroupunits', this.group)
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs', this.group)
      this.$store.dispatch('loadUserProfiles')
      this.$store.dispatch('loadChangeProfile')

      this.$log.debug('SITES LOADED: ', this.$store.getters.loadedSites)
      this.sites = this.$store.getters.loadedSites
      this.tokens = this.$store.getters.loadedTokens
      this.$log.debug('this sites is: ', this.sites)
      console.log(this.sites)
    },

    methods: {
      validateAddress (item) {
        console.log('validate this ', item)
        let location = {
          'FirstName': item.group,
          'LastName': item.sitecontactname,
          'FirmName': item.idnum,
          'SuiteOrApt': '',
          'Address1': '',
          'Address2': item.address,
          'City': item.city,
          'State': item.state,
          'ZIP5': item.zipcode,
          'ZIP4': '',
          'Phone': item.sitecontactnumber
        }
        this.$store.dispatch('validatePostalAddress', location)
      },
      validateField () {
        this.$refs.form.validate()
      },
      userlist (group) {
        this.$log.debug('%%%%% group passed is ', group)
        let people = this.$store.getters.userprofiles
        this.$log.debug('people rec is ', people)
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      addgroup () {
        this.$log.debug('want to add group ', this.newgroup)
        if (this.newgroup) {
          // this.currentgroups.push(this.newgroup)
          this.$log.debug('I am adding group ', this.newgroup)
          this.$store.dispatch('createUserGroup', this.newgroup)
          // make sure to load on a good add to the db
          this.$store.dispatch('loadUserGroups')
          this.newgroup = ''
        }
      },
      removeGroup (index) {
        let numelements = 1
        let grp = this.currentgroups[index]
        this.currentgroups.splice(index, numelements)
        this.$store.dispatch('removeUserGroup', grp)
        this.$store.dispatch('loadUserGroups')
      },
      editItem (item) {
        console.log('editing item')
        this.editedIndex = this.sites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.$log.debug('this is an edit')
      },
      verifyItem (item) {
        console.log('verify item')
        this.editedIndex = this.sites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogusps = true
      },
      deleteItem (item) {
        const index = this.sites.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.sites.splice(index, 1)) {
          // change the group and update it to group Rimi
          // this.$log.debug('site info is ', item)
          // this.$store.dispatch('loadunits')
          // this.$store.dispatch('loadsiteProfiles')
          // this.$store.dispatch('loadUserGroups')
          // this.$store.dispatch('loadSiteConfigs')
          // this.$store.dispatch('removeClientSite', item)
        }
      },
      closeusps () {
        this.dialogusps = false
        this.$store.dispatch('clearPostalMessage')
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save () {
        // enforce it to be unique
        // check for banned chars
        // is it unique in name?
        this.$log.debug(' can we save this ? ', this.editedItem.idnum)
        this.editedItem.idnum = this.editedItem.idnum.trim()
        this.editedItem.idnum = this.editedItem.idnum.replace(/\t/g, '')
        let sitenames = this.sites.map(entry => entry.idnum)
        if (sitenames.includes(this.editedItem.idnum)) {
          this.alertmessage = 'Site names must be unique'
          this.snackbar = true
          this.close()
        } else if (this.editedItem.idnum === '') {
          this.alertmessage = '# . $ are not allowed in a site name'
          this.snackbar = true
          this.close()
          return
        }
        // check unallowed chars?
        let notallowedchars = ''
        notallowedchars = this.editedItem.idnum.match(/\\t|[#\$\.]/gi)
        this.$log.debug('notallowedchars ', notallowedchars)
        if (notallowedchars) {
          this.alertmessage = '# . $ are not allowed in a site name'
          this.snackbar = true
          this.close()
          return
        }
        console.log(' we would save ', this.editedItem)
        if (!this.editedItem.creditproviderId) {
          this.editedItem.creditproviderId = ''
        }
        if (!this.editedItem.nightlyrestart) {
          this.editedItem.nightlyrestart = false
        }
        if (!this.editedItem.changeorderprofiles) {
          this.editedItem.changeorderprofiles = []
        }
        if (!this.editedItem.creditproviderLocationID) {
          this.editedItem.creditproviderLocationID = ''
        }
        if (!this.editedItem.creditproviderapikey) {
          this.editedItem.creditproviderapikey = ''
        }
        if (!this.editedItem.creditprovider) {
          this.editedItem.creditprovider = ''
        }
        if (!this.editedItem.safeType) {
          this.editedItem.safeType = ''
        }
        if (!this.editedItem.noteCapacity) {
          this.editedItem.noteCapacity = ''
        }
        if (!this.editedItem.state) {
          this.editedItem.state = 'NY'
        }
        if (!this.editedItem.locationTags) {
          this.editedItem.locationTags = []
        }
        if (!this.editedItem.provCredit) {
          this.editedItem.provCredit = false
        }
        if (!this.editedItem.time_deposit_summary) {
          this.editedItem.time_deposit_summary = ''
        }
        if (!this.editedItem.changeProvider) {
          this.editedItem.changeProvider = ''
        }
        if (!this.editedItem.changeSystemID) {
          this.editedItem.changeSystemID = ''
        }
        if (!this.editedItem.shipmentspermonth) {
          this.editedItem.shipmentspermonth = ''
        }
        const machineData = {
          idnum: this.editedItem.idnum.trim(),
          address: this.editedItem.address.trim(),
          sitekey: this.editedItem.sitekey.trim(),
          group: this.editedItem.group.trim(),
          nightlyrestart: this.editedItem.nightlyrestart,
          allowedusers: this.editedItem.allowedusers,
          changeSystemID: this.editedItem.changeSystemID,
          changeProvider: this.editedItem.changeProvider,
          changeorderprofiles: this.editedItem.changeorderprofiles,
          safeType: this.editedItem.safeType,
          noteCapacity: this.editedItem.noteCapacity,
          locationTags: this.editedItem.locationTags,
          provCredit: this.editedItem.provCredit,
          creditprovider: this.editedItem.creditprovider,
          shipmentspermonth: this.editedItem.shipmentspermonth,
          creditproviderId: this.editedItem.creditproviderId.trim(),
          creditproviderLocationID: this.editedItem.creditproviderLocationID.trim(),
          creditproviderapikey: this.editedItem.creditproviderapikey.trim(),
          wifipw: this.editedItem.wifipw.trim(),
          wifiaccess: this.editedItem.wifiaccess.trim(),
          city: this.editedItem.city.trim(),
          state: this.editedItem.state.trim(),
          zipcode: this.editedItem.zipcode.trim(),
          sitecontactnumber: this.editedItem.sitecontactnumber.trim(),
          sitecontactname: this.editedItem.sitecontactname.trim(),
          supportemail: this.editedItem.supportemail.trim(),
          supportnumber: this.editedItem.supportnumber.trim(),
          timezone: this.editedItem.timezone.trim(),
          time_open: this.editedItem.time_open,
          time_close: this.editedItem.time_close,
          time_eod: this.editedItem.time_eod,
          time_deposit_summary: this.editedItem.time_deposit_summary
        }
        this.$log.debug('checking ', this.editedItem.originalidnum, ' to ', this.editedItem.idnum)

        if (this.editedIndex > -1) {
          this.$log.debug('we saved on edit here')
          this.$log.debug('passing SITE KEY ', machineData.sitekey)
          if (this.editedItem.idnum !== this.editedItem.originalidnum) {
            // clone the profile to the new name
            this.$log.debug('cloning ', this.editedItem.originalidnum, ' to ', this.editedItem.idnum)
          }
          let rec = {
            originalidnum: this.editedItem.originalidnum,
            newidnum: this.editedItem.idnum,
            group: this.editedItem.group
          }
          this.$store.dispatch('clonesiteProfile', rec)
          this.$store.dispatch('updateMachineConfig', machineData)

          Object.assign(this.sites[this.editedIndex], this.editedItem)
          this.$store.dispatch('loadunits')
          this.$store.dispatch('loadsiteProfiles')
          this.$store.dispatch('loadSiteConfigs')
          this.$store.dispatch('loadUserProfiles')
          this.$store.dispatch('loadChangeProfile')

          this.$log.debug('SITES LOADED: ', this.$store.getters.loadedSites)
          this.sites = this.$store.getters.loadedSites
        } else {
          this.$log.debug('before save')
          // add in and assign postal safe
          this.virtualSafeId = 'PostalSafe-' + nanoid()
          // this call is only for corp clients to create a site for postal
          let rec = {
            machineData: machineData,
            safeid: this.virtualSafeId
          }
          this.$store.dispatch('createCorpPostalSite', rec)
          this.sites.push(this.editedItem)
        }
        this.$store.dispatch('loadunits')
        this.$store.dispatch('loadsiteProfiles')
        this.$store.dispatch('loadConfigs')
        this.$store.dispatch('loadUserProfiles')
        this.sites = this.$store.getters.loadedSites
        this.tokens = this.$store.getters.loadedTokens
        this.close()
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
